import { MODEL_CLASS_NAME_TO_SECTION } from 'models/constants/class-name-to-section'

/**
 * Gets a section name from a className.
 * @param  {string} className
 * @returns {string}
 */

function getSectionNameFromClassNameModelUtil (className) {
  return MODEL_CLASS_NAME_TO_SECTION[className]
}

export {
  getSectionNameFromClassNameModelUtil
}
